export enum EmergencyAccessStatusType {
  Invited = 0,
  Accepted = 1,
  Confirmed = 2,
  RecoveryInitiated = 3,
  RecoveryApproved = 4,
}
